module.exports = __webpack_public_path__ + "img/H1.d61705c1.png";